<template>
    <div style="min-height: 60vh;">
        <div class="bg-blur d-flex" style="object-fit: cover; background-repeat: no-repeat;" :style="{
            '--bg-url': 'url(' + $store.state.WebSite + 'files/_series/' + Item.Id + '/' + Item.Cover + ')',
        }">
            <b-img class="m-auto ratio-1440x452" style="object-fit: contain;"
                :src="$store.state.WebSite + 'files/_series/' + Item.Id + '/' + Item.Cover" fluid />
        </div>

        <b-container>
            <div class="py-5 ckEdit-content" v-html="IsNull(Item.Description)"></div>
            <h4>課程列表</h4>
            <div v-if="courses.data.length" ref="series" class="mt-4 mb-5">
                <div v-for="item in courses.data" :key="item.Id" class="p-0" @click="_go('./course?Id=' + item.Id)"
                    style="cursor:pointer">
                    <div class="card w-100 h-100 position-relative mb-2">
                        <div class="row no-gutters">
                            <div class="col bg-blur" style="background-size: cover; background-position: center;"
                                :style="{
                                    '--bg-url':
                                        'url(' + $store.state.FilePath + 'files/_course/' + item.Id + '/cover.png' + ')',
                                }">
                                <b-card-img v-if="item.Cover != ''" class="ratio-1440x452" style="object-fit: contain;"
                                    :src="$store.state.FilePath + 'files/_course/' + item.Id + '/cover.png'"></b-card-img>
                                <b-card-img v-else src="./asset/no-image.png"
                                    style="min-height: 200px; object-fit: cover; object-position: center;"
                                    class="h-100"></b-card-img>
                            </div>
                            <div class="col">
                                <b-card-body class="h-100 d-flex flex-column justify-content-between">
                                    <div class="d-flex align-items-start justify-content-between">
                                        <b-card-title class="mb-0 pr-3">
                                            {{ IsNull(item.Name) }}
                                        </b-card-title>
                                        <b-button
                                            variant="light"
                                            size="sm"
                                            class="favorite-icon-button"
                                            @mousedown.stop
                                            @click.stop.prevent="toggleFavorite(item)"
                                            :disabled="isFavoritePending(item)"
                                        >
                                            <b-icon-heart-fill v-if="isFavorite(item)" variant="danger"></b-icon-heart-fill>
                                            <b-icon-heart v-else variant="danger"></b-icon-heart>
                                        </b-button>
                                    </div>

                                    <div v-show="false" class="d-flex flex-wrap">
                                        <template>
                                            <b-badge v-for="(j2, j1) in item.Tags" :key="j1"
                                                v-bind="IsNull(courseStatusStyle[IsNull(j2)], courseStatusStyle[''])">
                                                {{ IsNull(j2) }}</b-badge>
                                        </template>
                                    </div>
                                    <p class="mt-3 text-muted clamp-2">{{ IsNull(item.Introduction) }}</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class=" text-primary">
                                            原價
                                            <span class="number font-weight-bold font-weight-bold"
                                                style="text-decoration:line-through;">{{
                                                    IsNull(item.OrginalPrice) | money(0, 2) }}</span>
                                        </div>

                                        <div>
                                            <span v-if="isApplyNow(item)" class="course-badge mr-2">報名中</span>
                                            <span class="font-weight-bold text-dark">課程費用</span>
                                            <span class="number font-weight-bold h4 text-danger ml-2">{{
                                                IsNull(item.Price) | money(0, 2) }}</span>
                                        </div>
                                    </div>
                                    <div class="signin mt-3" v-if="item.canSignin">
                                        <b-button block class="mr-1 position-relative" data-splide-no-drag
                                            @mousedown.stop @click.stop.prevent="butGo(0, item)">我要報名</b-button>
                                        <b-button v-if="item.CA_IS_GROUP" block class="position-relative"
                                            @mousedown.stop @click.stop.prevent="butGo(1, item)">團體報名</b-button>
                                    </div>
                                </b-card-body>
                            </div>
                        </div>
                        <b-link class="stretched-link text-decoration-none" aria-label="查看課程詳情"
                            :to="{ path: '/course', query: { Id: item.Id } }" />
                    </div>

                </div>
            </div>
            <b-alert show v-if="courses.data.length == 0" variant="primary">尚無課程</b-alert>
        </b-container>
    </div>
</template>

<script>
import { apiGetCourseSeries, apiDictionaryList } from '@/api/API.js';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import courseFavorite from '@/mixins/courseFavorite.js';

export default {
    name: 'CourseSeriesDetails',
    mixins: [courseFavorite],
    components: {
    },
    data() {
        return {
            Id: '',
            Item: '',

            //
            courseStatusStyle: {
                '': { class: 'mr-1', variant: 'primary' },
                規劃中: { class: 'mr-1', variant: 'primary' },
                已截止: { class: 'mr-1', variant: 'primary' },
                招生中: { class: 'mr-1', variant: 'primary' },
                已成班: { class: 'mr-1', variant: 'primary' },
                開課中: { class: 'mr-1', variant: 'primary' },
                早鳥優惠: { class: 'mr-1', variant: 'primary' },
                仍可報名: { class: 'mr-1', variant: 'primary' },
                已結束: { class: 'mr-1', variant: 'primary' },
                最新課程: { class: 'mr-1', variant: 'primary' },
                熱門課程: { class: 'mr-1', variant: 'danger' },
            },
            files: {},
            data_in: {},
            data: {},
            courses: {
                data: {},
            },
            splideOpts: {
                type: 'slide',
                rewind: true,
                perPage: 1,
                perMove: 1,
                focus: 0,
                padding: 0,
                gap: 0,
                trimSpace: false,
                arrows: false,
                pagination: false,
            }
        };
    },
    mounted() {
        if (this.$route.query.id) {
            this.Id = this.$route.query.id;
            this.Init();
            this.loadFavoriteProducts();
        } else {
            this._go('./');
        }
        // let navBgSwitch=this._storeData('navBgSwitch')
        // if(this.IsNull(navBgSwitch)!=''){
        //   navBgSwitch(false)
        // }
        // this.sessionF1()
        // this.FunctionToken(this.FunctionGetListSeries, {});
    },
    watch: {
        'course.data.length'(n) {
            this.$nextTick(() => {
                const s = this.$refs.series?.splide;
                if (!s) return;
                const perPage = s.options.perPage;
                s.update({
                    type: n > perPage ? 'loop' : 'slide',
                    pagination: n > 1,
                    drag: n > 1,
                });
                s.refresh();
                s.go(0);
            });
        }
    },
    methods: {
        isApplyNow(item) {
            if (!item) return false;
            const start = item.ApplyStart ? new Date(item.ApplyStart) : null;
            const end = item.ApplyEnd ? new Date(item.ApplyEnd) : null;
            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) return false;
            const now = new Date();
            const endAt = new Date(end.getTime());
            if (endAt.getHours() === 0 && endAt.getMinutes() === 0 && endAt.getSeconds() === 0) {
                endAt.setHours(23, 59, 59, 999);
            }
            return now >= start && now <= endAt;
        },
        Init() {
            apiDictionaryList({
                Paging: {
                    pageSize: 9999,
                    pageNumber: 1,
                },
                Search: {
                    Category: 'class',
                    Type: 'series',
                },
            })
                .then((res) => {
                    this.Item = res.data.filter((item) => {
                        return item.Id == this.Id;
                    });
                    this.Item = this.Item[0];
                })
                .catch((err) => {
                    console.log(err);
                    //alert(err.response.data);
                });

            apiGetCourseSeries(this.Id)
                .then((res) => {
                    console.log(res);
                    this.courses.data = res.data;
                    // this.Item = res.data;
                })
                .catch((err) => {
                    console.log(err);
                    //alert(err.respone.data);
                });
        },
        TableGo(data) {
            // this.sessionF1('course', data);
            console.log(data);
        },
    },
};
</script>

<style lang="scss" scoped>
.courses {
    align-content: stretch;

    .mainImage {
        .card-img {
            aspect-ratio: 16 / 9;
            max-width: 400px;
        }
    }

    .description {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
        margin-bottom: 1rem;
    }

    .price {
        display: flex;

        li {
            margin-right: 1rem;

            .number {
                color: #e73827;
                font-size: 1.3rem;
                font-weight: bold;
            }
        }
    }

    &.list {
        .course {
            border-width: 0 0 1px 0;
            flex: 1 2 200px;

            .card-body {
                padding: 0rem 2rem 1.5rem 2rem;
            }
        }

        .mainImage {
            .card-img {
                width: 400px;
            }
        }

        .signin {
            white-space: nowrap;
        }
    }

    &.grid {
        .description {
            display: none;
        }

        .end {
            display: none;
        }

        .begin-signin {
            display: none;
        }

        .end-signin {
            display: none;
        }

        .signin {
            display: none;
        }
    }

    .course {
        height: 100%;
    }
}

/* slide */
.splide__slide>* {
    width: 100%;
    height: 100%;
}

.splide__pagination {
    // margin-bottom: ;
    bottom: -2rem !important;
}

.list {
    .card-img-left {
        height: 200px;
    }
}

.favorite-icon-button {
    position: relative;
    z-index: 5;
    border-radius: 999px;
    flex: 0 0 auto;
}
</style>
